import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { AggrDeviceFieldThrResponse } from '@/api/routes/stat/types';

import { fetchStaticAggrDeviceMileageFieldThr } from '../actionCreators';

interface InitialState {
  aggrThrByMileageField: AggrDeviceFieldThrResponse,
  isLoading: boolean,
  error: string,
}

const initialState: InitialState = {
  aggrThrByMileageField: [],
  isLoading: false,
  error: '',
};

export const staticAggrDeviceByMileageFieldSlice = createSlice({
  name: 'aggrDeviceByMileageField',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchStaticAggrDeviceMileageFieldThr.fulfilled.type]:
      (state, action: PayloadAction<AggrDeviceFieldThrResponse>) => {
        state.isLoading = false;
        state.error = '';
        state.aggrThrByMileageField = action.payload;
      },
    [fetchStaticAggrDeviceMileageFieldThr.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchStaticAggrDeviceMileageFieldThr.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export default staticAggrDeviceByMileageFieldSlice.reducer;
